






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EUserStatus } from '@zunta/configurations'
import { EStatusType } from '@/components/statuses/EStatusType'
import { USER_STATUSES_LABEL_MAP } from '@/constants'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusUser extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.default
    }

    switch (this.$props.status) {
      case EUserStatus.ACTIVE:
        return EStatusType.success
      case EUserStatus.WAITING:
        return EStatusType.pending
      case EUserStatus.NOT_ACTIVE:
        return EStatusType.error
      default:
        return EStatusType.default
    }
  }

  get text (): string {
    if (!this.$props.status) {
      return ''
    }
    return USER_STATUSES_LABEL_MAP[this.$props.status]
  }
}
